import { render, staticRenderFns } from "./finishingsBox.vue?vue&type=template&id=bd3d781e"
import script from "./finishingsBox.vue?vue&type=script&lang=js"
export * from "./finishingsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports